import React, { useEffect, useState } from "react";
import "./Style.css";
import Layout from "../../Components/Layout/Layout";
import TabsAiProfile from "../../Components/AiProfile/TabsAiProfile/Index";
import video from "../../../src/Assets/video.svg";
import videodash from "../../../src/Assets/play-button.png";
import TrainingModal from "../../../src/Components/Training/TrainingModal";
import { AI_PROFILE_VIDEO } from "../../Utils/Constants";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
import TabsAiProfileMobile from "../../Components/AiProfile/TabsAiProfile/TabsAiProfileMobile";
const AiProfile = () => {
  const [refState, setRefState] = React.useState(false);
  const [refStatenew, setRefStatenew] = React.useState(false);
  const [refStateShared, setRefStateShared] = React.useState(false);
  const [refStateSharednew, setRefStateSharednew] = React.useState(false);
  const [isDecisionMakerExcel, setIsDecisionMakerExcel] = React.useState(false);
  const [shareRecord, setShareRecord] = React.useState(false);
  useEffect(() => {
    localStorage.removeItem("cns");
    localStorage.removeItem("cip");
    localStorage.removeItem("cdp");
  }, []);

  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [isTabletPortrait, setIsTabletPortrait] = useState(false);
  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
    );
    setIsTabletPortrait(mediaQuery.matches);
    const handleChange = (e) => setIsTabletPortrait(e.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, []);
  const [isTabletLandscape, setIsTabletLandscape] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: landscape)",
    );
    const handleChange = (e) => {
      setIsTabletLandscape(e.matches);
    };
    setIsTabletLandscape(mediaQuery.matches);
    mediaQuery.addEventListener("change", handleChange);
    return () => {
      mediaQuery.removeEventListener("change", handleChange);
    };
  }, []);
  return (
    <>
      <Layout
        className={"paddingSet"}
        setRefState={setRefState}
        refStatenew={refStatenew}
        setRefStatenew={setRefStatenew}
        refState={refState}
        setRefStateShared={setRefStateShared}
        refStateSharednew={refStateSharednew}
        setRefStateSharednew={setRefStateSharednew}
        refStateShared={refStateShared}
      >
        <div className="child-section-of-everypage">
          {isMobile ? (
            ""
          ) : isTabletPortrait ? (
            <AiLeadsAction
              setIsDecisionMakerExcel={setIsDecisionMakerExcel}
              setShareRecord={setShareRecord}
            />
          ) : (
            <AiLeadsAction
              setIsDecisionMakerExcel={setIsDecisionMakerExcel}
              setShareRecord={setShareRecord}
            />
          )}
          {isMobile ? (
            <TabsAiProfileMobile
              setRefStatenew={setRefStatenew}
              setRefState={setRefState}
              setRefStateShared={setRefStateShared}
              setRefStateSharednew={setRefStateSharednew}
              isDecisionMakerExcel={isDecisionMakerExcel}
              setIsDecisionMakerExcel={setIsDecisionMakerExcel}
              shareRecord={shareRecord}
              setShareRecord={setShareRecord}
              isMobile={isMobile}
            />
          // ) : isTabletPortrait ? (
          //   <TabsAiProfileMobile
          //     setRefStatenew={setRefStatenew}
          //     setRefState={setRefState}
          //     setRefStateShared={setRefStateShared}
          //     setRefStateSharednew={setRefStateSharednew}
          //     isDecisionMakerExcel={isDecisionMakerExcel}
          //     setIsDecisionMakerExcel={setIsDecisionMakerExcel}
          //     shareRecord={shareRecord}
          //     setShareRecord={setShareRecord}
          //     isMobile={isMobile}
          //     isTabletPortrait={isTabletPortrait}
          //   />
          ) : (
            <TabsAiProfile
              setRefStatenew={setRefStatenew}
              setRefState={setRefState}
              setRefStateShared={setRefStateShared}
              setRefStateSharednew={setRefStateSharednew}
              isDecisionMakerExcel={isDecisionMakerExcel}
              setIsDecisionMakerExcel={setIsDecisionMakerExcel}
              shareRecord={shareRecord}
              setShareRecord={setShareRecord}
               isMobile={isMobile}
              isTabletPortrait={isTabletPortrait}
              isTabletLandscape={isTabletLandscape}
            />
          )}
        </div>
      </Layout>
    </>
  );
};
export default AiProfile;
